/** Parameter `date` is passed to `Date` constructor */
export const getArticleSchemaDatePublished = (date?: string | number) => {
  try {
    const result = date
      ? new Date(date)?.toISOString().split('T')[0]
      : undefined;
    return result;
  } catch (e) {
    console.log(e);
    return undefined;
  }
};

/** Parameter `date` is passed to `Date` constructor */
export const getBlogDisplayDate = (date?: string | number, locale?: string) => {
  try {
    const result = date
      ? new Date(date)?.toLocaleDateString(locale, {
          month: 'long',
          year: 'numeric',
          day: 'numeric',
        })
      : '';
    return result;
  } catch (e) {
    console.log(e);
    return '';
  }
};
